'use client';

import { useEffect, useState } from 'react';
import { Trans } from 'next-i18next';

/**
 * @description Marketing slogan component for the login page. Ex: 'let b upgrade you'.
 *
 * The client i18n instance loads the `common` namespace asynchronously, so on SSR the `Trans`
 * would render the raw key while the client renders the translation — a hydration mismatch.
 * Gate it behind a mounted flag so SSR and the first client render agree (empty heading), then
 * the translated slogan appears after hydration.
 */
export const AuthMarketingSlogan = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);

  return (
    <h1 className="text-xl text-dark lg:text-2xl">
      {mounted && (
        <Trans
          i18nKey="login.bestie.title"
          components={{
            br: <br />,
            span: <span className="underline decoration-secondary decoration-wavy" />,
          }}
        />
      )}
    </h1>
  );
};
